<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action">
      <div class="button button-submit" @click="action.save">
        <button class="btn" type="button" name="button">決定</button>
      </div>
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <p class="popup-title-main">タグの編集</p>
          <p class="popup-title-sub">{{state.visibleTargetName}}内の同じタグを一括で変更します。</p>
        </div>
        <div class="popup-content">
          <div class="hdg04 mb20">タグのタイトル</div>
          <div class="formparts text">
            <input type="text" v-model="data.name" @keydown.enter="action.enterInput">
            <p v-if="validation.isSubmit && !validation.title.require" class="error-message">タイトルは必須です</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  setup (props, context) {
    const store = context.root.$store
    const { tag } = store.state

    const state = reactive({
      visibleTargetName: computed(() => tag.currentTypeName)
    })

    const data = reactive({
      name: ''
    })

    // 初期値を設定する
    const orginalData = store.getters['tag/getCurrentList']
    data.name = orginalData.name

    const validation = reactive({
      isChanged: computed(() => {
        return data.name !== orginalData.name 
      }),
      isSubmit: false,
      title: {
        require: computed(() => data.name !== '')
      },
      all: computed(() => {
        // 決定ボタン押下前(isSubmit:false)の場合はチェックしない
        return validation.isSubmit &&
          validation.title.require
      })
    })

    const close = () => {
      context.emit('closeTagEdit')
    }

    const action = reactive({
      enterInput: (event) => {
        if (event.keyCode === 13) {
          action.save()
        }
      },
      save: async() => {
        validation.isSubmit = true
        if (validation.all) {
          // 変更点がなければ閉じるだけ
          if (!validation.isChanged) {
            context.emit('closeTagEdit')
          } else {
            const params = {
              id: tag.currentId,
              name: data.name
            }
            await store
              .dispatch('tag/update', params)
              .then(() => {
                store.dispatch('common/showToast', {
                  text: 'タグの名称を変更しました'
                })
              })
            context.emit('closeTagEdit')
            context.emit('save')
          }
        }
      }
    })

    return {
      state,
      data,
      action,
      validation,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup {
  &-content {
    padding: 20px;
  }
  &-action {
    .button-row-wrap {
      padding: 20px;
      width: calc(100% - 93px);
    }
  }
}


</style>
